import { API_BASE } from '@/Module/Core/Constant';

export const LESSON_API = {
  GET_LIST_BY_COURSE_ID: `${API_BASE}/Lesson/GetByCourseId`,
  GET_BY_ID: `${API_BASE}/Lesson/{id}`,
  GET_BY_FRIENDLY_TOKEN: `${API_BASE}/Lesson/GetLessonByFriendlyToken`,
  GET_RELATED_LESSON_LIST_BY_ID: `${API_BASE}/Lesson/GetRelatedLesson`,
  GET_LIKE_BY_ENTITY_ID_USER_ID: `${API_BASE}/Like/GetByLikeEntityTypeIdEntityIdUserId`,
  POST_LIKE_BY_ID: `${API_BASE}/Like`,
  DELETE_LIKE_BY_ID: `${API_BASE}/Like`,
  GET_BOOKMARK_BY_ID: `${API_BASE}/BookMark/GetByEntityTypeIdEntityIdUserId`,
  POST_BOOKMARK_BY_ID: `${API_BASE}/BookMark`,
  DELETE_BOOKMARK_BY_ID: `${API_BASE}/BookMark`,
  GET_COURSE_BY_LESSON_ID: `${API_BASE}/Lesson/GetCourseByLessonId`,
  GET_TEACHER_BY_LESSON_ID: `${API_BASE}/Lesson/GetTeacherByLessonId`,
  GET_COURSE_CATEGORY_BY_COURSE_ID: `${API_BASE}/CourseCategory/GetByCourseId`,
  GET_POOYAN_PLAYER_TOKEN: `${API_BASE}/Lesson/GetPooyanTokenPlayer`,
  LESSON_VIDEO_STATISTICS: `${API_BASE}/lesson-videos/logs`,
};
